import { get } from "../client";
import { STATS } from "../routes";

export default {
  get: async () => await get(STATS),
};
